import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '@semantle/shared/locales/en.json';
import frTranslations from '@semantle/shared/locales/fr.json';
import elTranslations from '@semantle/shared/locales/el.json';

i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: enTranslations },
      fr: { translation: frTranslations },
      el: { translation: elTranslations },
    },
    fallbackLng: 'en', // Use English if translation is missing
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'], // Check localStorage first (saved preference), then browser language
      caches: ['localStorage'], // Cache language preference
      lookupLocalStorage: 'i18nextLng', // Key to use in localStorage
    },
  });

export default i18n;

